require('./bootstrap');
require('./commons');

import Snotify, {
  SnotifyPosition
} from 'vue-snotify';
import VueMask from 'v-mask';
import VueMoney from 'v-money';
import vSelect from 'vue-select';

const snotify_options = {
  toast: {
    timeout: 3000,
    showProgressBar: false,
    position: SnotifyPosition.rightTop
  }
}

Vue.use(Snotify, snotify_options);
Vue.use(VueMask);
Vue.use(VueMoney);

Vue.component('v-select', vSelect)
Vue.component('register-address-component', require('./components/RegisterAddressComponent.vue'))
Vue.component('register-address-component', require('./components/RegisterAddressComponent.vue'))
Vue.component('dynamic-contacts-form', require('./components/DynamicContactsForm.vue'))

require('@/components/hire-wizard');

const app = new Vue({
  el: '#app',
  props: [
    'flashMessages',
  ],

  data: {
    handled_flash_messages: false,
  },

  mounted() {
    this.handleFlashMessages();
    this.setupAxiosInterceptors();
  },

  methods: {
    throwFlashMessage(type, message) {
      this.$snotify[type](message);
    },

    setupAxiosInterceptors() {
      window.axios.interceptors.response.use(function(config) {
        return config;
      }, (error) => {
        this.handleCommonAjaxErrors(error);
      });
    },

    handleCommonAjaxErrors(error) {
        if (error.response.status == 401) {
            this.throwFlashMessage('error', 'Sessão expirada, por favor atualize sua página para voltar a utilizar o sistema.');
        } else if (error.response.status == 403) {
            this.throwFlashMessage('error', 'Permissão negada');
            throw error;
        } else {
            throw error;
        }
    },

    handleFlashMessages() {
      const flashMessages = document.querySelectorAll('#flash-messages-container > span');
      for (let i = 0; i < flashMessages.length; i++) {
        const flashNode = flashMessages[i];
        const type = flashNode.className;
        const message = flashNode.innerHTML;
        this.throwFlashMessage(type, message);
      }
      this.handled_flash_messages = true;
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/login.js